module.exports = __webpack_public_path__ + "static/media/cool.3bfa1d19.png";